import {DownloadExportService} from './service/download-export.service';
import {StringToDate} from './common/pipe/date.pipe';
import {DateTimeRangeComponent} from './view/date-time-range/date-time-range.component';
import {DialogComponent} from './view/dialog/dialog.component';
import {BlockTempsComponent} from './view/block-temps/block-temps.component';
import {BlockService} from './service/BlockService';
import {ExportService} from './service/export.service';
import {AuthInterceptor} from './interceptor/auth-interceptor';
import {ActiveStateService} from './service/ActivateStateService';
import {AuthService} from './service/AuthService';
import {TrainingService} from './service/training.service';
import {HierarchyBackupService} from './service/hierarchy-backup.service';
import {HierarchyService} from './service/hierarchy.service';
import {HierarchyTreeComponent} from './view/hierarchy-tree/hierarchy-tree.component';
import {TrainingTreeComponent} from './view/training-tree/training-tree.component';
import {TrainingComponent} from './view/training/training.component';
import {TrainingAreaComponent} from './view/training-area/training-area.component';
import {TreeModule} from 'angular-tree-component';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LOCALE_ID, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {RouterModule} from '@angular/router';
import {HttpModule} from '@angular/http';
import {isConnected, Routes, portugalMenus, isPorgugal} from './app.routes';
/* Material Desgin */
import { MAT_DIALOG_DATA, MatDialogRef,  MatPaginatorIntl, DateAdapter } from '@angular/material';


import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {ToolbarComponent} from './layout/toolbar/toolbar.component';
import {SidebarComponent} from './layout/sidebar/sidebar.component';
import {UserService} from './service/UserService';
import {VersionCheckService} from './service/version-check.service';
import {PageNotFoundComponent} from './view/page-not-found/page-not-found.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {Animation} from './library/Animation';
import {SessionService} from './service/SessionService';
import {TranslateProvider} from './Factory/TranslateFactory';
import {RouterService} from './service/RouterService';
import {TimesheetComponent} from './view/timesheet/timesheet.component';
import {TimesheetAreaComponent} from './view/timesheet-area/timesheet-area.component';
import {NgxPermissionsModule, NgxPermissionsService} from 'ngx-permissions';
import {HomeComponent} from './view/home/home.component';
import {ExportComponent} from './view/export/export.component';
import {EmitterService} from './service/EmitterService';
import {DownloadExportComponent} from './view/download-export/download-export.component';
import {MytimesheetComponent} from './view/mytimesheet/mytimesheet.component';
import {IntelciaAccordinComponent} from './view/intelcia-accordin/intelcia-accordin.component';
import {IntelciaTreeComponent} from './view/intelcia-tree/intelcia-tree.component';
import {MotifService} from './service/MotifService';
import {BadrequestComponent} from './view/badrequest/badrequest.component';
import {AlertComponent} from './view/alert/alert.component';
import {AlertService} from './service/alert.service';
import {ReclamationComponent} from './view/reclamation/reclamation.component';
import {ConfirmatonDialogComponent} from './view/block-temps/confirmaton-dialog/confirmaton-dialog.component';
import {TraitementmasseComponent} from './view/traitementmasse/traitementmasse.component';
import {ReclamationViewComponent} from './view/reclamation-view/reclamation-view.component';
import {CoachingService} from './service/coaching.service';
import {CanActivateCoach} from './guard/coach-guard.service';
import {BreakService} from './service/break.service';
import {DetailsBlocksComponent} from './view/details-blocks/details-blocks.component';
import {TraitementIncoComponent} from './view/traitement-inco/traitement-inco.component';
import {NgxMaskModule} from 'ngx-mask';
import {DurationPipe} from './pipe/duration.pipe';
import {MY_TOKEN, O2TourComponent} from './view/o2-tour/o2-tour.component';
import {ExportDialogComponent} from './view/intelcia-tree/export-dialog/export-dialog.component';
import {TimeZoneService} from './service/TimeZoneService';
import {ReclamationDialogComponent} from './view/block-temps/reclamation-dialog/reclamation-dialog.component';
import {ValidationVerroComponent} from './view/validationVerro/validationVerro.component';
import {RoleService} from './service/RoleService';
import {SearchtimesheetComponent} from './view/searchtimesheet/searchtimesheet.component';
import {LoggerService} from './service/LoggerService';
import {O2TourModule} from './o2-tour/o2-tour.module';
import {O2TourService} from './o2-tour';
import {MessageService} from './service/message.service';
import {FaqComponent} from './view/faq/faq.component';
import {ReopenRequestsProcessComponent} from './view/reopen-requests-process/reopen-requests-process.component';
import {ReopenRequestsSuiviComponent} from './view/reopen-requests-suivi/reopen-requests-suivi.component';
import {OpenFicheService} from './service/open-fiche.service';
import {ObjectNotificationService} from './service/obj-notification.service';
import {ValidateDemandeDialogComponent} from './view/block-temps/validate-demande-dialog/validate-demande-dialog.component';
import {InsertRealiseDialogComponent} from './view/Insert-realise-dialog/insert-realise-dialog.component';
import {InsertDialogComponent} from './view/Insert-dialog/insert-dialog.component';
import {CustomPaginator, setLangOfPaginator} from './helpers/CustomPaginator';
import {UpdateRealiseDialogComponent} from './view/update-realise-dialog/update-realise-dialog.component';
import {DashboardComponent} from './view/bi/dashboard/dashboard.component';
import {ReopenRequestsHistoryComponent} from './view/reopen-requests-history/reopen-requests-history.component';
import {InjectionComponent} from './view/injection/injection.component';
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {InjectionService} from './service/injection.service';
import {AuthModule} from './auth/auth.module';
import {environment} from '../environments/environment';
import {NgSelectModule} from '@ng-select/ng-select';
import localePt from '@angular/common/locales/pt';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeTr from '@angular/common/locales/tr';
import {registerLocaleData} from "@angular/common";
import {EnvService} from "./service/env.service";
import {MutualisationDialogComponent} from "./view/block-temps/mutualisation-dialog/mutualisation-dialog.component";
import {inputMaskDirective} from "./directives/inputPhoneMask";
import {InjectionModule} from "./modules/injection/injection.module";
import {MaterialModule} from "./material-module";
import { CODE_LANG } from './helpers/GlobalConstants';
import {DelegationModule} from './modules/delegation/delegation.module';
import {ToastrModule} from 'ngx-toastr';
import {WatchDogService} from './service/WatchDogService';
import {OrderByPipe} from './pipe/order.pipe';
import {UnlockRequestsProcessComponent} from './view/unlock-requests-process/unlock-requests-process.component';
import {UnlockRequestsHistoryComponent} from './view/unlock-requests-history/unlock-requests-history.component';
import {UnlockRequestsSuiviComponent} from './view/unlock-requests-suivi/unlock-requests-suivi.component';
import {ModalUserGuideComponent} from './layout/user-guide/user-guide.component';
import {FeatureAccessService} from './service/feature-access.service';

registerLocaleData(localePt);
registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeTr);

console.log(22, isConnected, isPorgugal);

@NgModule({
  declarations: [
    /* Component Interface*/
    AppComponent,
    DateTimeRangeComponent,
    ToolbarComponent,
    ModalUserGuideComponent,
    SidebarComponent,
    PageNotFoundComponent,
    HierarchyTreeComponent,
    TimesheetComponent,
    TimesheetAreaComponent,
    TrainingTreeComponent,
    TrainingComponent,
    TrainingAreaComponent,
    HomeComponent,
    ExportComponent,
    BlockTempsComponent,
    DialogComponent,
    InsertDialogComponent,
    DownloadExportComponent,
    StringToDate,
    MytimesheetComponent,
    IntelciaAccordinComponent,
    IntelciaTreeComponent,
    BadrequestComponent,
    AlertComponent,
    BadrequestComponent,
    ReclamationComponent,
    InsertRealiseDialogComponent,
    UpdateRealiseDialogComponent,
    ConfirmatonDialogComponent,

    TraitementmasseComponent,
    ReclamationViewComponent,

    DetailsBlocksComponent,
    TraitementIncoComponent,
    DurationPipe,
    OrderByPipe,
    O2TourComponent,
    ExportDialogComponent,
    ValidateDemandeDialogComponent,
    ReclamationDialogComponent,
    ValidationVerroComponent,
    SearchtimesheetComponent,
    FaqComponent,
    ReopenRequestsProcessComponent,
    ReopenRequestsHistoryComponent,
    ReopenRequestsSuiviComponent,
    UnlockRequestsProcessComponent,
    UnlockRequestsHistoryComponent,
    UnlockRequestsSuiviComponent,
    DashboardComponent,
    InjectionComponent,
    MutualisationDialogComponent,
    inputMaskDirective
  ],
  imports: [
    /* Material Desgin */
    MaterialModule,
    /* Modules & Router & i18n & Ngx Permisison*/
    HttpModule,
    HttpClientModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TreeModule,
    TranslateModule.forRoot(TranslateProvider),
    NgxJsonViewerModule,
    /*    NgxPermissionsModule.forRoot()*/
    AuthModule.forRoot(
      environment.oauth,
      []),
    RouterModule.forRoot(isPorgugal ? portugalMenus : Routes, {useHash: true}),
    NgxPermissionsModule.forRoot(),
    NgxMaskModule.forRoot(),
    O2TourModule.forRoot(),
    NgSelectModule,
    DelegationModule,
    InjectionModule.forRoot({}),
    ToastrModule.forRoot({
      enableHtml: true
    }),
  ],
  providers: [
    TimeZoneService,
    CoachingService,
    CanActivateCoach,
    InjectionService,
    MotifService,

    RouterService,
    UserService,

    RoleService,
    VersionCheckService,
    SessionService,
    HierarchyService,
    HierarchyBackupService,
    MessageService,
    ObjectNotificationService,
    TrainingService,
    AuthService,
    ActiveStateService,
    ExportService,
    BlockService,
    EmitterService,
    WatchDogService,

    DownloadExportService,
    BreakService,
    AlertService,
    FeatureAccessService,
    EnvService,
    LoggerService,
    O2TourService,
    OpenFicheService,
    /* Library*/
    Animation,
    /*Component*/
    /* Provider */

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: MatPaginatorIntl, deps: [TranslateService],
      useFactory: (translate: TranslateService) => {
      return CustomPaginator(translate);
    }},

    NgxPermissionsService,
    /*CanActivate*/
    HierarchyTreeComponent,
    TrainingTreeComponent,
    {provide: MatDialogRef, useValue: {}},
    {provide: MAT_DIALOG_DATA, useValue: []},
    {provide: MY_TOKEN, useValue: ''},
    // { provide: LocationStrategy, useClass: HashLocationStrategy},
    O2TourComponent
  ],
  bootstrap: [AppComponent, O2TourComponent],
  entryComponents: [ModalUserGuideComponent,MutualisationDialogComponent, DialogComponent, InsertRealiseDialogComponent, UpdateRealiseDialogComponent,
    ValidateDemandeDialogComponent, ConfirmatonDialogComponent, ExportDialogComponent, ReclamationDialogComponent, O2TourComponent],
  exports: [BlockTempsComponent, ToastrModule]
})


export class AppModule {
  constructor(private translate: TranslateService, private adapter: DateAdapter<any>,
              public i: MatPaginatorIntl) {
    translate.addLangs(['en', 'fr', 'es', 'tr', 'de']);
    const codeLang=localStorage.getItem(CODE_LANG);
    if(codeLang && this.translate.langs.indexOf(codeLang)!=-1){
        this.translate.use(codeLang);
    }else{
        this.translate.use('fr');
    }
    translate.onLangChange.subscribe((lang) => {
      adapter.setLocale(lang.lang);
      const t = translate.translations[translate.currentLang];
      setLangOfPaginator(t, i);
      i.changes.next();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts